export const checkSubPaths = (path) => {
  const splittedPath = path.split('/');
  return splittedPath[1] === 'classroom' && splittedPath[2] === 'me';
};

export const willHideDefaultNav = (path) =>
  !!(path.includes('/classrooms/me/') || path.includes('/certificate'));
